













import {
  Vue,
  Component,
} from "@/shared/vuepack";

@Component
export default class HsaBankOnboardingFooter extends Vue {
}
